//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region Util Imports

import * as $ from 'jquery'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion


import { i18n } from './i18n/common.i18n'
import { CommonHelper } from '../../helpers/common-helper'
import { OperatorLayoutSettings } from '../../helpers/operator-layout-settings'
import { BaseGridController, ScopeBaseGrid } from './common.base.grid.controller'
import { GridDetailsSettings } from './grid-details/grid-details.directive.controller'
import { Api, LocalDictionaryFactory } from './../api/api.module'
import { EventsNames } from '../../helpers/events-names'
import { MapOptions, Map } from './map2/map.directive.controller'
import { OpMarker } from '../../models/custom/op-map-area'
import { Enums } from '../../models/common/enums'

import { MapHelper } from '../../helpers/map-helper'
import { LocalizationHelper } from '../../helpers'
import { UserSessionService } from '../../services/user-session'
import { SystemService } from '../../services/system'

export class GridPositions {
    static left = "OnTheLeft"
    static right = "OnTheRight"
    static top = "OnTheTop"
    static bottom = "OnTheBottom"
    static hide = "Hide"
}

export interface ScopeBaseGridsterGrid extends ScopeBaseGrid {
    // gridster
    gridsterOpts: any
    gridsterGridOpts: any
    gridsterSecondRowOpts: any

    isSecondRowVisible: boolean
    isLandscape: boolean
    closeSecondRow()

    // settings for controls in second row
    isDetailsVisible: boolean

    // details
    gridDetailsSettings: GridDetailsSettings

    // map directive data
    isMapVisible: boolean
    mapOptions: MapOptions

    // pin/unpin grid
    pinSwitchOptions: DevExpress.ui.dxButtonOptions
    returnButtonOptions: DevExpress.ui.dxButtonOptions
    isGridShown: boolean

    onReturnButtonClick: () => void
    onSwitchButtonClick: () => void
    switchUnpinnedClass: string
    switchButtonTitle: string
    onFocus: () => void

    isNarrowGrid: boolean

    // translations
    showGridTranslation: string
    noDefinedContent: string
}

export class BaseGridGridsterController extends BaseGridController {
    private GRIDSTER_SETTINGS = 'GRIDSTER_SETTINGS'
    private IS_SECOND_ROW_VISIBLE = 'IS_SECOND_ROW_VISIBLE'
    private SECOND_ROW_VISIBLE_TYPE = 'SECOND_ROW_VISIBLE_TYPE'
    protected SECOND_ROW_POSITION = 'SECOND_ROW_POSITION'

    private selectedRowsData: any[]
    private isMarkerClicked: boolean
    private pinButton: DevExpress.ui.dxButton
    private isGridPinned: boolean

    private map: Map
    // data for maps
    private actualData: any[]

    protected mapDeferred: JQueryDeferred<Map>

    constructor(
        protected $scope: ScopeBaseGridsterGrid,
        protected $timeout: ng.ITimeoutService,
        protected $state: StateService,
        protected userSession: UserSessionService,
        protected systemService: SystemService,
        protected api: Api,
        protected localDictionary: LocalDictionaryFactory,
        protected type: number, gridDetailsSettings: GridDetailsSettings, name: string, referenceType: Enums.ReferenceType, private addMap: boolean = false) {

        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, type, referenceType)

        $scope.showGridTranslation = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowGrid)
        $scope.noDefinedContent = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoDefinedContent)

        this.GRIDSTER_SETTINGS += name
        this.IS_SECOND_ROW_VISIBLE += name
        this.SECOND_ROW_VISIBLE_TYPE += name
        this.SECOND_ROW_POSITION += name

        this.setGridsterMapOptions()

        $scope.gridDetailsSettings = gridDetailsSettings

        $scope.gridsterOpts = {
            columns: 4, // the width of the grid, in columns
            pushing: false,
            swapping: false,
            floating: false,
            outerMargin: false, // whether margins apply to outer edges of the grid
            isMobile: false, // stacks the grid items if true
            mobileBreakPoint: 200, // if the screen is not wider that this, remove the grid layout and stack the items
            mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
            minColumns: 1, // the minimum columns the grid must have
            minRows: 1, // the minimum height of the grid, in rows
            maxRows: 4,
            defaultSizeX: 2, // the default width of a gridster item, if not specifed
            defaultSizeY: 1, // the default height of a gridster item, if not specified
            minSizeX: 1, // minimum column width of an item
            maxSizeX: 4, // maximum column width of an item
            minSizeY: 1, // minumum row height of an item
            maxSizeY: 4, // maximum row height of an item
            resizable: {
                enabled: false
            },
            draggable: {
                enabled: false
            }
        }

        $scope.$on(EventsNames.CLOSE_MAP, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.closeSecondRow()
        })

        $scope.$on(EventsNames.SERVER_EXCEPTION_OCCURED, () => {
            this.$scope.showGrid = true
        })

        $scope.closeSecondRow = () => {
            this.hideSecondRow()
            $('#DetailsButton').blur()
            $('#MapButton').blur()
            this.$scope.$broadcast('secondrowclosed')
            if (!$scope.isGridShown) {
                $scope.isGridShown = true
            }
        }

        var isSecondRowVisible = OperatorLayoutSettings.getSetting(this.IS_SECOND_ROW_VISIBLE, false)
        if (isSecondRowVisible) this.showSecondRow()
        else this.hideSecondRow()

        var visibleType = OperatorLayoutSettings.getSetting(this.SECOND_ROW_VISIBLE_TYPE)
        if (visibleType == 'map') {
            $scope.isMapVisible = true
            $scope.isDetailsVisible = false
        } else if (visibleType == 'details') {
            $scope.isMapVisible = false
            $scope.isDetailsVisible = true
        }

        $scope.$watch(() => {
            return angular.element('.content').innerHeight()
        }, (contentHeight) => {
            $scope.gridsterOpts.rowHeight = (contentHeight - 10) / 4
            var windowWidth = angular.element(window).width()
            if ($scope.gridsterOpts.rowHeight < 150 && windowWidth >= 768) $scope.gridsterOpts.rowHeight = 150
            else if (windowWidth < 768) $scope.gridsterOpts.rowHeight = 300

            $timeout(() => {
                if (this.dataGrid) this.dataGrid.updateDimensions()
            })
        })

        $scope.$watch(() => {
            return angular.element(window).width()
        }, (windowWidth) => {
            if (windowWidth < 768) $scope.gridsterOpts.isMobile = true
            else $scope.gridsterOpts.isMobile = false
        })

        $scope.$watch(() => {
            return $scope.isSecondRowVisible && !$scope.isLandscape && (angular.element('.content').innerWidth() < 450)
        }, (gridWidth) => {
            if (gridWidth) {
                angular.element('.dx-datagrid-search-panel').addClass('dx-datagrid-search-panel-narrow')
            } else {
                angular.element('.dx-datagrid-search-panel').removeClass('dx-datagrid-search-panel-narrow')
            }
        })

        //pinned grid
        this.isGridPinned = true
        $scope.isGridShown = true

        $scope.onFocus = () => {
            if ($scope.isGridShown) {
                if (!this.isGridPinned && !$scope.isMapVisible) {
                    $scope.isGridShown = false
                    $scope.gridsterSecondRowOpts = { sizeX: 4, sizeY: 4, row: 0, col: 0 }
                    $timeout(() => {
                        this.resizeSecondRow()
                    }, 1000)
                }
            }
        }

        $scope.onReturnButtonClick = () => {
            if (this.isGridPinned) {
                $scope.isGridShown = false
            } else {
                $scope.isGridShown = true
            }
            $timeout(() => {
                var secondRowPosition = OperatorLayoutSettings.getSetting(this.SECOND_ROW_POSITION, GridPositions.bottom)
                this.setGridsterPosition(secondRowPosition)
            })
        }

        $scope.switchButtonTitle = i18n("Common", "Unpin")
        $scope.onSwitchButtonClick = () => {
            if (this.isGridPinned) {
                this.isGridPinned = false
                $scope.switchUnpinnedClass = 'fa-rotate-90'
                $scope.switchButtonTitle = i18n("Common", "Pin")
            }
            else {
                this.isGridPinned = true
                $scope.switchUnpinnedClass = ''
                $scope.switchButtonTitle = i18n("Common", "Unpin")
            }
        }

        // end of pinned grid
    }

    protected setGridsterPosition = (position) => {
        if (position == GridPositions.hide)
            this.hideSecondRow()
        if (this.$scope.isSecondRowVisible) {
            OperatorLayoutSettings.setSetting(this.SECOND_ROW_POSITION, position)
            var isLandscape = true
            var gridsterGridOpts, gridsterSecondRowOpts
            switch (position) {
                case GridPositions.left:
                    this.$scope.isNarrowGrid = true
                    gridsterGridOpts = { sizeX: 2, sizeY: 4, row: 0, col: 2 }
                    gridsterSecondRowOpts = { sizeX: 2, sizeY: 4, row: 0, col: 0 }
                    isLandscape = false
                    break
                case GridPositions.right:
                    this.$scope.isNarrowGrid = true
                    gridsterGridOpts = { sizeX: 2, sizeY: 4, row: 0, col: 0 }
                    gridsterSecondRowOpts = { sizeX: 2, sizeY: 4, row: 0, col: 2 }
                    isLandscape = false
                    break
                case GridPositions.top:
                    this.$scope.isNarrowGrid = false
                    gridsterGridOpts = { sizeX: 4, sizeY: 2, row: 2, col: 0 }
                    gridsterSecondRowOpts = { sizeX: 4, sizeY: 2, row: 0, col: 0 }
                    break
                case GridPositions.bottom:
                    this.$scope.isNarrowGrid = false
                    gridsterGridOpts = { sizeX: 4, sizeY: 2, row: 0, col: 0 }
                    gridsterSecondRowOpts = { sizeX: 4, sizeY: 2, row: 2, col: 0 }
                    break
            }
            this.$scope.gridsterGridOpts = gridsterGridOpts
            this.$scope.gridsterSecondRowOpts = gridsterSecondRowOpts
            this.$timeout(() => {
                this.$scope.isLandscape = isLandscape
                this.$timeout(() => {
                    if (this.dataGrid) this.dataGrid.updateDimensions()
                    this.resizeSecondRow()
                }, 0)
            }, 500)
        }
    }

    protected getMarkers(data: any[], map: Map, selected: boolean) {
        var markers: OpMarker[] = []

        if (data)
            data.forEach(dataRow => {
                let marker = CommonHelper.getMarkerFromData(dataRow, (id) => {
                    this.onMarkerClick([id])
                })

                if (marker)
                    markers.push(marker)
            })
        return markers
    }

    protected onMarkerClick(rowsIds: number[]) {
        var selectedRows: any[] = this.dataGrid.getSelectedRowKeys()
        if (selectedRows.length != rowsIds.length || selectedRows.filter(r => rowsIds.indexOf(r) == -1).length > 0 || rowsIds.filter(r => selectedRows.indexOf(r) == -1).length > 0) {
            this.isMarkerClicked = true
            this.dataGrid.selectRows(rowsIds, false)
        }
        this.scrollToSelected(this.dataGrid)
    }

    protected onSelectionChanged = (e: any) => {
        if (!this.isMarkerClicked) {
            this.mapDeferred
                .promise()
                .then((map: Map) => {
                    const markers: OpMarker[] = e.selectedRowsData != null
                        ? this.getMarkers(e.selectedRowsData, map, true)
                        : this.getMarkers(e.component.getSelectedRowsData(), map, true)

                    map.setSelectedMarkers(markers, true, true)
                })
        }
        else {
            this.isMarkerClicked = false
        }

        this.selectedRowsData = this.dataGrid.getSelectedRowsData()

        var objects = this.selectedRowsData.map(s => {
            s.id = s[CommonHelper.idField]
            s.referenceId = s[CommonHelper.idReferenceField]
            return s
        })

        if (this.$scope.isDetailsVisible && objects.length > 10) {
            if (this.$scope.isSecondRowVisible) {
                this.show10RowsInfoPopup()
            }
            objects = objects.slice(0, 10)
        }
        if (this.$scope.gridDetailsSettings)
            this.$scope.gridDetailsSettings.objects = objects
        if (!this.$scope.$$phase) this.$scope.$digest()
    }

    private showSecondRow = () => {
        this.$scope.isSecondRowVisible = true
        OperatorLayoutSettings.setSetting(this.IS_SECOND_ROW_VISIBLE, true)
        var secondRowPosition = OperatorLayoutSettings.getSetting(this.SECOND_ROW_POSITION, GridPositions.bottom)
        this.setGridsterPosition(secondRowPosition)
        this.$timeout(() => {
            if (this.dataGrid) {
                if (this.dataGrid.totalCount() > 0 && this.dataGrid.getSelectedRowsData().length < 1) {
                    if (!this.$scope.isMapVisible) this.dataGrid.selectRowsByIndexes([0])
                }
                this.dataGrid.updateDimensions()
            }
        }, 500)
    }

    private hideSecondRow = () => {
        this.$scope.isNarrowGrid = false
        this.$scope.isSecondRowVisible = false
        OperatorLayoutSettings.setSetting(this.IS_SECOND_ROW_VISIBLE, false)
        this.$scope.gridsterGridOpts = { sizeX: 4, sizeY: 4, row: 0, col: 0 }
        this.$timeout(() => {
            if (this.dataGrid)
                this.dataGrid.updateDimensions()
        }, 500)
    }

    protected resizeSecondRow = () => {
        if (this.addMap && this.$scope.isSecondRowVisible && this.$scope.isMapVisible) {
            if (this.map != null) {
                this.map.resize()
            }
        }

        if (this.$scope.isDetailsVisible && this.$scope.isSecondRowVisible) {
            this.$scope.$broadcast(EventsNames.UPDATE_CHART)
            this.$scope.$broadcast(EventsNames.UPDATE_GRID_DETAILS)
        }
    }

    protected show10RowsInfoPopup() {
        CommonHelper.openInfoPopup(i18n('Grid', 'Max10Rows'), 'info', 5000)
    }

    protected showPreviewDetails = (target = '#DetailsButton') => {
        var result = false
        if (this.$scope.isSecondRowVisible && this.$scope.isDetailsVisible) {
            result = true
        }
        else if (!this.$scope.isSecondRowVisible) {
            var rowsCount = this.dataGrid.getSelectedRowsData().length
            if (rowsCount > 10) {
                this.show10RowsInfoPopup()
            }
            this.showSecondRow()
        }
        this.$scope.isMapVisible = false
        this.$scope.isDetailsVisible = true
        OperatorLayoutSettings.setSetting(this.SECOND_ROW_VISIBLE_TYPE, 'details')
        return result
    }

    protected showMapDetails(target = '#MapButton') {
        var result = false
        if (this.$scope.isSecondRowVisible && this.$scope.isMapVisible) {
            result = true
        }
        else if (!this.$scope.isSecondRowVisible) {
            this.showSecondRow()
        }
        this.$scope.isMapVisible = true
        this.mapDeferred = $.Deferred<Map>()
        this.$scope.isDetailsVisible = false
        OperatorLayoutSettings.setSetting(this.SECOND_ROW_VISIBLE_TYPE, 'map')
        this.mapDeferred.promise().then(map => {
            //TO DO!!! Jałowizna

            map.setMarkers(this.getMarkers(this.actualData, map, false)) // TODO dodać promise do setMarkers i setSelectedMarkers po zakończeniu dodawania markerów

            const needZoom: boolean = _.size(this.selectedRowsData) > 0

            map.setSelectedMarkers(this.getMarkers(this.selectedRowsData, map, true), true, needZoom)
        })
        return result
    }

    protected onGridInit(gridId: number) {
        var visibleType = OperatorLayoutSettings.getSetting(this.SECOND_ROW_VISIBLE_TYPE)
        this.$scope.$root.$broadcast(EventsNames.UPDATE_GRID_BUTTONS + gridId, this.$scope.isSecondRowVisible, visibleType)
    }

    protected onDataReady = (data: any[]) => {
        this.$scope.showGrid = true

        if (this.addMap) {
            this.actualData = data
            if (!this.selectedRowsData && this.dataGrid) {
                this.selectedRowsData = this.dataGrid.getSelectedRowsData()
            }

            this.mapDeferred
                .promise()
                .then((map: Map) => {
                    map.setMarkers(this.getMarkers(data, map, false), true)
                })
        }

        if (this.$scope.isSecondRowVisible && !this.$scope.isMapVisible && this.$scope.isDetailsVisible) {
            this.$timeout(() => {
                if (this.dataGrid && this.dataGrid.getSelectedRowKeys().length == 0) {
                    this.dataGrid.selectRowsByIndexes([0])
                }

                if (this.$scope.gridDetailsSettings && this.$scope.gridDetailsSettings.refreshDelegate) {
                    this.$scope.gridDetailsSettings.refreshDelegate()
                }
            })
        }
    }

    private scrollToSelected(component) {
        var scrollable = component.getView('rowsView')._scrollable
        var selectedRowElements = component.element().find('tr.dx-selection')
        var gridHeight = component.getView('gridView')._rootElement[0].clientHeight
        if (selectedRowElements && selectedRowElements[0] && scrollable) {
            var lastScrollLeft = scrollable.scrollLeft()
            scrollable.scrollTo({ left: lastScrollLeft, top: selectedRowElements[0].offsetTop - (gridHeight / 3) })
        }
    }

    // Map

    protected getGridsterMap(): JQueryPromise<Map> {
        return this.mapDeferred.promise()
    }

    private setGridsterMapOptions(): void {
        this.mapDeferred = $.Deferred<Map>()
        this.isMarkerClicked = false

        MapHelper
            .getDefaultOptions(this.userSession.getDataProvider())
            .then((mapOptions: MapOptions) => {
                mapOptions.onMapInit = (map: Map) => {
                    this.map = map
                    this.mapDeferred.resolve(map)
                }

                this.onGridsterMapConfiguration(mapOptions)

                this.$scope.mapOptions = mapOptions
            })
    }

    /**
     * Override in the subclass to alter options of the map.
     */
    protected onGridsterMapConfiguration(mapOptions: MapOptions): void { }

    // Map End
}
